var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_16354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81997 11L7.99997 13.17C8.13373 13.3071 8.30096 13.4069 8.48512 13.4595C8.66928 13.5121 8.86399 13.5158 9.04997 13.47C9.23712 13.4265 9.40993 13.3356 9.55179 13.206C9.69364 13.0764 9.79977 12.9125 9.85997 12.73L13.44 2.00002C13.5147 1.79897 13.5301 1.5807 13.4844 1.37114C13.4387 1.16159 13.3337 0.969571 13.1821 0.817909C13.0304 0.666247 12.8384 0.561322 12.6288 0.515606C12.4193 0.46989 12.201 0.485305 12 0.56002L1.26997 4.14002C1.08122 4.20449 0.913116 4.3182 0.783022 4.46939C0.652928 4.62058 0.565569 4.80377 0.529974 5.00002C0.493233 5.17851 0.501412 5.36333 0.553776 5.53788C0.60614 5.71243 0.701049 5.87123 0.829974 6.00002L3.56997 8.74002L3.47997 12.21L5.81997 11Z",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1199 0.780029L3.56995 8.74003",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_16354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.52044d126d621f0a7c28a489c96a9903.svg";
export { ForwardRef as ReactComponent };